import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { faqData } from '../data/mock';
import { HelpCircle, ArrowRight, MessageCircle } from 'lucide-react';
import ChatWidget from '../components/common/ChatWidget';

const FAQPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      
      <main>
        {/* Hero Section */}
        <section className="py-16 bg-white border-b border-slate-100">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <HelpCircle className="w-8 h-8 text-blue-600" />
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Häufig gestellte Fragen
              </h1>
              <p className="text-lg text-slate-600">
                Hier finden Sie Antworten auf die wichtigsten Fragen rund um Finanzierungen, unseren Service und den Ablauf.
              </p>
            </div>
          </div>
        </section>

        {/* FAQ Content */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto">
              {faqData.map((category, categoryIndex) => (
                <div key={categoryIndex} className="mb-12">
                  <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
                    <span className="w-10 h-10 bg-blue-600 text-white rounded-lg flex items-center justify-center text-sm font-bold">
                      {categoryIndex + 1}
                    </span>
                    {category.category}
                  </h2>
                  
                  <Accordion type="single" collapsible className="space-y-3">
                    {category.questions.map((item, questionIndex) => (
                      <AccordionItem
                        key={questionIndex}
                        value={`${categoryIndex}-${questionIndex}`}
                        className="bg-white rounded-xl border border-slate-200 px-6 data-[state=open]:shadow-lg transition-shadow"
                      >
                        <AccordionTrigger className="text-left font-semibold text-slate-900 hover:text-blue-600 py-5">
                          {item.q}
                        </AccordionTrigger>
                        <AccordionContent className="text-slate-600 pb-5 leading-relaxed">
                          {item.a}
                        </AccordionContent>
                      </AccordionItem>
                    ))}
                  </Accordion>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Still have questions */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-2xl mx-auto text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <MessageCircle className="w-8 h-8 text-blue-600" />
              </div>
              <h2 className="text-3xl font-bold text-slate-900 mb-4">
                Noch Fragen?
              </h2>
              <p className="text-slate-600 mb-8">
                Unsere Experten stehen Ihnen gerne zur Verfügung. Kontaktieren Sie uns für eine persönliche Beratung.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <Link to="/kontakt">
                  <Button size="lg" className="bg-blue-600 hover:bg-blue-700 text-white">
                    Kontakt aufnehmen
                    <ArrowRight className="w-5 h-5 ml-2" />
                  </Button>
                </Link>
                <a href="tel:+498912345678">
                  <Button size="lg" variant="outline" className="border-slate-300">
                    +49 (0) 15511 427039
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <ChatWidget />
    </div>
  );
};

export default FAQPage;
